import { LEVEL } from '@/interfaces/level.interface'

function adjustHeights(
  features: LEVEL[],
  minHeight: number = 3,
  gap: number = 0.5,
  base: number = 0
) {
  const updatedFeatures: LEVEL[] = []

  features.forEach((f, iteration) => {
    if (iteration === 0) {
      // If height doesn't exist, set it to minHeight
      if (!f.properties.height) {
        f.properties.height = minHeight
      }
      // If height is less than minHeight, set it to minHeight
      if (f.properties.height < minHeight) {
        f.properties.height = minHeight
      }

      f.properties.elevation = base
      updatedFeatures.push(f)
    } else {
      if (!f.properties.height) {
        f.properties.height = minHeight
      }
      // If height is less than minHeight, set it to minHeight
      if (f.properties.height < minHeight) {
        f.properties.height = minHeight
      }

      f.properties.elevation = updatedFeatures[iteration - 1].properties.height + gap
      f.properties.height = f.properties.elevation + f.properties.height
      updatedFeatures.push(f)
    }
  })
  return updatedFeatures
}

export default adjustHeights
